export function getConfigProps (apiUri = '/api', staticUri = '/widget/0.8/') {
    let a = document.createElement('a');
    let isProd = process.env.NODE_ENV === 'production';
    a.href = Array.from(document.querySelectorAll('script')).map(script => script.src).find(src => src.match(isProd ? 'widget/0.8' : '/js/all.js')) || '';

    return {
        apiUrl: a.origin + apiUri,
        staticUrl: a.origin + staticUri,
    };
}
